import React from "react";
import { bool, node, string } from "prop-types";
import { classes } from "../utils/classes";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { sxClassName, sxProps, sxPropTypes } from "../props/sx";

const Footer = ({
	utility = { ...utilityProps },
	sx = { ...sxProps },
	spacing = { ...spacingProps },
	isBorderNone = false,
	className = "",
	children,
}) => {
	return (
		<footer
			className={classes(
				"footer",
				...utilityClassName(
					deepMergeProps(isBorderNone ? { border: { width: 0 } } : {}, pureProps(utility)),
				),
				...sxClassName(sx),
				...spacingClassName(spacing),
				className,
			)}
		>
			{children}
		</footer>
	);
};

Footer.propTypes = {
	utility: utilityPropTypes,
	sx: sxPropTypes,
	spacing: spacingPropTypes,
	isBorderNone: bool,
	className: string,
	children: node.isRequired,
};

export default Footer;
